import React from 'react';

const currentYear = new Date().getFullYear();

const Foooter = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4 flex flex-col justify-between h-full">
        <div>
          <div className="flex flex-wrap justify-between items-center">
            <div className="w-full sm:w-auto text-center sm:text-left mb-4 sm:mb-0">
              <h5 className="text-lg font-semibold">Ihh Wibu Community</h5>
              <p className="text-sm">© {currentYear} by Ihh Wibu, All rights reserved.</p>
            </div>
            <div className="w-full sm:w-auto text-center">
              <nav className="flex justify-center sm:justify-end space-x-4">
                <a href="#" className="text-gray-400 hover:text-white">Home</a>
                <a href="https://www.instagram.com/ihhwibu_community/" className="text-gray-400 hover:text-white">Instagram</a>
                <a href="/#/attribution" className="text-gray-400 hover:text-white">Attributon</a>
              </nav>
            </div>
          </div>
          <div className="mt-8 text-center">
            <p className="text-xs text-gray-500">
              Designed with Waifu ❤️ by <a href="https://github.com/yogaardiansyah" className="text-gray-400 hover:text-white">Yoga Ardiansyah</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Foooter;
